<template>
  <div class="record mainWrap">
    <!--需要修添加class-->
    <el-container style="height: 100%; background-color: rgba(0, 0, 0, 0)">
      <!-- 左边导航栏 -->
      <el-aside style="width: auto">
        <leftNav msg="/DownloadSuggestions"></leftNav
        ><!--改组件名-->
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-main>
        <el-tabs v-model="activeName">
          <el-tab-pane label="上传文件" name="first">
            <el-input
                    v-model="input"
                    placeholder="请输入所属的组"
                    style="width: 27.5%"
            ></el-input>
            <br />
            <br />
            <el-upload
                    multiple
                    name="files"
                    class="upload-demo"
                    ref="upload"
                    accept=".MOV,.mov,.mp4,.png,.jpg,.jpeg,.ppt,.pptx,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                    :action="actionUrl"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :file-list="files"
                    :auto-upload="false"
                    :headers="urlHeaders"
                    :on-success="success">
              <el-button slot="trigger" size="small"  @click="fileValue" type="primary" >选取文件
              </el-button>
              <el-button style="margin-left: 10px" size="small" type="success" @click="submitUpload">上传到服务器
              </el-button>
              <div slot="tip" class="el-upload__tip">只能上传视频、图片、文档</div>
            </el-upload>
            <br />
            <br />
            <br />
            <br />

            <template>
              <div>
                <el-select v-model="value" placeholder="请选择">
                  <el-option
                          v-for="item in options"
                          :key="item.id"
                          :label="item.groupName"
                          :value="item.id">
                  </el-option>
                </el-select>
                <el-input v-model="input1" placeholder="输入文件名" style="width: 27.5%" ></el-input>
                <div class="divz" style="display: inline-bilck">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <el-button type="primary" @click="getVideoListByGroupId()">查找
                </el-button>
                <br />
                <br />
                <el-button type="success" @click="getVideoGroup(value)">按组下载</el-button>
              </div>
              <br />
              <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="fileName" label="文件名称">
                </el-table-column>
                <el-table-column prop="groupName" label="所属组">
                </el-table-column>
                <el-table-column prop="lastUpdateTimeString" label="上传时间">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">下载二维码
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-image-viewer v-if="fileimage" :on-close=" () => {(fileimage = false), (filepaths = '');}" :url-list="[filepaths]" />
              <!-- 分页 -->
              <el-pagination class="pagination" background layout="prev, pager, next" :total="listTotal" :current-page.sync="nowPage" @current-change="handleCurrentChange" @size-change="handleCurrentSizeChange">
              </el-pagination>
            </template>
          </el-tab-pane>
          <el-tab-pane label="意见建议导出" name="second">
            <div class="DeviceServiceDownload mainWrap">
              <!--需要修添加class-->
              <el-container style="height: 100%; background-color: rgba(0, 0, 0, 0)">
                <!-- 右侧主体部分 -->
                <el-scrollbar class="machineWrap" style="height: 100%; width: 100%">
                  <el-main>
                    <div>
                      <div class="block">
                        <el-date-picker v-model="value1" type="daterange" :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        <el-button id="btn" type="primary" @click="send" style="margin-left: 20px" >立即导出</el-button>
                      </div>
                    </div>
                  </el-main>
                </el-scrollbar>
              </el-container>
            </div>
          </el-tab-pane>
          <el-tab-pane label="用户操作记录导出" name="fourth">
            <div class="DeviceServiceDownload mainWrap">
              <!--需要修添加class-->
              <el-container style="height: 100%; background-color: rgba(0, 0, 0, 0)" >
                <!-- 右侧主体部分 -->
                <el-scrollbar class="machineWrap" style="height: 100%; width: 100%" >
                  <el-main>
                    <div>
                      <div class="block">
                        <el-date-picker v-model="value1" type="daterange" :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" >
                        </el-date-picker>
                        <el-button id="btn" type="primary" @click="sendUser" style="margin-left: 20px" >立即导出
                        </el-button>
                      </div>
                    </div>
                  </el-main>
                </el-scrollbar>
              </el-container>
            </div>
          </el-tab-pane>
          <el-tab-pane label="用户管理" name="fifth">
            <div>
              <el-form :inline="true" :model="accountForm" class="demo-form-inline">
                <el-form-item label="用户名">
                  <el-input v-model="accountForm.userName" placeholder="用户名"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                  <el-input v-model="accountForm.phone" placeholder="手机号"></el-input>
                </el-form-item>
                <el-form-item label="角色">
                  <el-select clearable v-model="accountForm.role.id" placeholder="角色">
                    <el-option v-for="item in roleOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="工厂">
                  <el-select clearable v-model="accountForm.tenantCode" placeholder="工厂">
                    <el-option v-for="item in tenantOptions" :key="item.id" :label="item.tenantName" :value="item.tenantCode"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="findAccountSubmit">查询</el-button>
                </el-form-item>
                <el-button type="success" @click="addAccountFun">添加用户</el-button>
              </el-form>

              <el-table :data="personnelManagementTableData" border style="width: 100%">
                <el-table-column  prop="userName" label="用户名">
                </el-table-column>
                <el-table-column  prop="phone" label="手机号"> </el-table-column>
                <el-table-column  prop="role.name" label="角色">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100%">
                  <template slot-scope="scope">
                    <el-button @click="personnelManagementHandleClick(scope.row)" type="text" size="small">详情</el-button>
                    <el-button style="color: red" @click="delAccountIsShow(scope.row)" type="text" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <el-pagination class="pagination" background layout="prev, pager, next" :total="accountListTotal" :current-page.sync="accountNowPage" @current-change="accountHandleCurrentChange" @size-change="accountHandleCurrentSizeChange"></el-pagination>
              <el-dialog title="删除" :visible.sync="delAccountShow" width="30%">
                <span>确定要删除{{ delAccountFrom.userName }}吗？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="delAccountClose">取 消</el-button>
                  <el-button type="primary" @click="delAccount">确 定</el-button>
                </span>
              </el-dialog>
              <el-dialog @closed="delAccountCloseFun('addAccountFrom')" title="添加用户" :visible.sync="addAccountTable">
                <el-form ref="addAccountFrom" :model="addAccountFrom" :rules="addRules">
                  <el-form-item label="用户名" :label-width="formLabelWidth" prop="userName">
                    <el-input v-model="addAccountFrom.userName" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="登录名" :label-width="formLabelWidth" prop="login">
                    <el-input v-model="addAccountFrom.login" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="所属公司" :label-width="formLabelWidth" prop="company">
                    <el-input v-model="addAccountFrom.company" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="工作" :label-width="formLabelWidth" prop="jobName">
                    <el-input v-model="addAccountFrom.jobName" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
                    <el-input v-model="addAccountFrom.phone" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="密码" :label-width="formLabelWidth" prop="password">
                    <el-input v-model="addAccountFrom.password" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="角色" :label-width="formLabelWidth" prop="roleId">
                    <el-select @change="roleChange" v-model="addAccountFrom.roleId" placeholder="角色">
                      <el-option v-for="item in roleOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="工厂权限" :label-width="formLabelWidth" prop="tenantCode">
                    <el-select @change="tenantChange" style="width: 80%" v-model="addAccountFrom.tenantCode" :multiple="addAccountIsMultiple==1" :disabled="tenantIsShow" placeholder="工厂权限">
                      <el-option v-for="item in addAccountTenantOptions" :key="item.id" :label="item.tenantName" :value="item.tenantCode"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="isShop==1" label="车间权限" :label-width="formLabelWidth" prop="shopId">
                    <el-select style="width: 80%" v-model="addAccountFrom.shopId" placeholder="车间权限">
                      <el-option v-for="item in shopList" :key="item.id" :label="item.nameZh" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="isMachine==1" label="设备权限" :label-width="formLabelWidth"  prop="machineId">
                    <el-select style="width: 80%" v-model="addAccountFrom.machineId" multiple placeholder="设备权限">
                      <el-option v-for="item in machineList" :key="item.id" :label="item.nameZh" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="submitAddAccountForm('addAccountFrom')">立即创建</el-button>
                    <el-button @click="resetAddAccountForm('addAccountFrom')">重置</el-button>
                  </el-form-item>
                </el-form>
              </el-dialog>
              <el-dialog class="fontLineHeight" @closed="accountCloseFun" title="详细信息" :visible.sync="dialogTableVisible">
                <div>
                  用户名: {{ gridData.userName }} <br />
                  手机号：{{ gridData.phone }} <br />
                  登录名：{{ gridData.login }}<br />

                <div v-if="roleValue.id == 7">
                  所属工厂：{{gridData.tenantName}}<br>
                  所属角色：{{accountRowName}}<br>
                  机器权限：
                  <div style="display: inline-block" v-for="machine in gridData.machines" :key="machine.id">
                    <span>{{machine.nameZh}}&nbsp;&nbsp;</span>
                  </div>
                </div>
                <div v-if="roleValue.id == 8">
                  所属工厂：{{gridData.tenantName}}<br>
                  所属角色：{{accountRowName}}<br>
                  车间权限：
                  <div style="display: inline-block" v-for="shop in gridData.shops" :key="shop.id">
                    <span>{{shop.nameZh}}&nbsp;&nbsp;</span>
                  </div>
                </div>

                <div v-if="roleValue.id !=7 && roleValue.id!=8">
                  工厂权限：
                  <el-select style="width: 80%" v-model="accountTenantCodeList" multiple placeholder="工厂权限">
                    <el-option v-for="item in tenantOptions" :key="item.id" :label="item.tenantName" :value="item.tenantCode"></el-option>
                  </el-select>
                  <div v-if="gridData.machines != null" style="display: inline-block">
                    机器权限：
                  <div style="display: inline-block" v-for="machine in gridData.machines" :key="machine.id">
                    <span>{{machine.nameZh}}&nbsp;&nbsp;</span>
                  </div>
                  </div><br />

                  所属角色：
                  <el-select @change="roleSelect" v-model="accountRowName" placeholder="请选择" size="mini">
                    <el-option v-for="item in roleOptions" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                  <br />
                </div>
                  用户状态：
                  <el-select @change="frozenStatusSelect" v-model="accountfrozenStatus.label" placeholder="请选择" size="mini">
                    <el-option v-for="item in frozenStatus" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <br />
                  最后一次登录时间：{{ gridData.lastLoginTime }}
                </div>
                <el-button @click="updateAccount" v-show="accountUpdateShow" type="primary">更新用户信息
                </el-button>
              </el-dialog>
            </div>
          </el-tab-pane>
          <el-tab-pane label="生成二维码记录" name="six">
            <div class="DeviceServiceDownload mainWrap">
              <!--需要修添加class-->
              <el-container style="height: 100%; background-color: rgba(0, 0, 0, 0)" >
                <!-- 右侧主体部分 -->
                <el-scrollbar class="machineWrap" style="height: 100%; width: 100%" >
                  <el-main>
                    <div>
                      <div class="block">
                        <el-date-picker v-model="codeSearchDate" type="daterange" :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" >
                        </el-date-picker>
                        <el-button id="btn" type="primary" @click="downloadCode" style="margin-left: 20px" >立即导出
                        </el-button>
                      </div>
                    </div>
                  </el-main>
                </el-scrollbar>
              </el-container>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
  </div>
</template>


<script>
  import leftNav from "@/components/nav.vue";
  import { formatDate } from "../assets/js/date.js";
  import ElImageViewer from "element-ui/packages/image/src/image-viewer";
  import md5 from 'blueimp-md5'
  export default {
    name: "DownloadSuggestions",
    components: {
      leftNav,
      ElImageViewer,
    },
    data() {
      return {
        addAccountIsMultiple: 1,
        tenantIsShow: true,
        addAccountTenantOptions: [],
        shopList: [],
        machineList: [],
        isShop: -1,
        isMachine: -1,
        isTenant: -1,
        delAccountFrom: {
          id: "",
          userName: "",
          isDel: 1,
        },
        delAccountShow: false,
        addRules: {
          phone: [{ required: true, message: "请输入手机号", trigger: "blur" }, {pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, required: true, message: "请输入正确的手机号",},],
          login: [{ required: true, message: "请输入登录名", trigger: "blur" }],
          userName: [{ required: true, message: "请输入用户名", trigger: "blur" },],
          password: [{ required: true, message: "请输入密码", trigger: "blur" }],
          jobName: [{ required: false, message: "请输入工作", trigger: "blur" }],
          tenantCode: [{ required: true, message: "请至少选择一个工厂", trigger: "blur" }],
          roleId: [{ required: true, message: "请选择角色", trigger: "blur" }],
          shopCode: [{ required: true, message: "请选择车间", trigger: "blur" }],
          machineCode: [{ required: true, message: "请选择设备", trigger: "blur" }]
        },
        addAccountFrom: {
          phone: "",
          userName: "",
          roleId: "",
          password: "",
          jobName: "",
          login: "",
          company: "",
          tenantCode: "",
          shopId: "",
          machineId: ""
        },
        addAccountRoleId: "",
        addAccountTable: false,
        tenantCodeIsSame: true,
        accountTenantCodeList: [],
        originalAccountTenantCodeList: [],
        updateAccountFrom: {
          id: "",
          role: {
            id: "",
          },
          frozenStatus: "",
          tenantCode: "",
        },
        accountForm: {
          tenantCode: "",
          userName: "",
          phone: "",
          role: {
            id: "",
          },
        },
        accountRowName: "",
        accountfrozenStatus: {},
        frozenStatus: [
          {
            value: 0,
            label: "正常",
          },
          {
            value: 1,
            label: "冻结",
          },
        ],
        accountUpdateShow: false,
        roleOptions: [],
        tenantOptions: [],
        roleSelectValue: -1,
        frozenStatusValue: -1,
        roleValue: {},
        gridData: {},
        dialogTableVisible: false,
        dialogFormVisible: false,
        form: {
          name: "",
          region: "",
          date1: "",
          date2: "",
          delivery: false,
          type: [],
          resource: "",
          desc: "",
        },
        formLabelWidth: "120px",
        personnelManagementTableData: [],
        fileimage: false,
        filepaths: "",
        activeName: "first",
        files: [],
        actionUrl: "/url/uploadAliYunFile",
        urlHeaders: {},
        tableData: [],
        route: "",
        factory_id: "",
        signTime: "",
        auth_Code: "",
        language: "",
        sign: "",
        input: "",
        input2: "",
        multipleSelection: [],
        accountNowPage: 1,
        nowPage: 1,
        nowPageSize: 10,
        listTotal: null,
        accountListTotal: null,
        options: [],
        value: "",
        value1: "",
        formLabelAlign: {
          name: "",
          region: "",
          type: "",
        },
        grafanaOptions: [
          {
            value: "/addAllUser",
            label: "将所有未冻结和未删除的人员账号添加至grafana",
          },
          {
            value: "/addOnePerson",
            label: "根据用户id添加",
          },
          {
            value: "/deleteGrafanaUser",
            label: "根据id删除用户",
          },
        ],
        grafanaValue: "",
        factoryList1: null,
        factoryValue: "",
        input1: "",
        // 生成设备二维码查询条件
        codeSearchDate:''
      };
    },
    methods: {
      tenantChange(tenantCode) {
        this.machineList = null
        this.shopList = null
        this.addAccountFrom.machineId = ""
        this.addAccountFrom.shopId = ""
        this.axios({
          method: "get",
          url: "/url/personnelManagement/getAddAccountSelect/"+tenantCode.toString()+"/"+this.addAccountFrom.roleId,
        }).then((res) => {
          this.machineList = res.data.machineList
          this.shopList = res.data.shopList
        });
      },
      roleChange(roleId) {
        this.addAccountFrom.tenantCode = ""
        this.addAccountFrom.machineId = ""
        this.addAccountFrom.shopId = ""
        this.axios({
          method: "get",
          url: "/url/personnelManagement/getAddAccountData/"+roleId,
        }).then((res) => {
          this.tenantIsShow = false
          this.isShop = res.data.idShop
          this.isMachine = res.data.isMachine
          this.addAccountTenantOptions = res.data.tenantList
          this.addAccountIsMultiple = res.data.isMultiple
        });
      },
      delAccountCloseFun(formName) {
        this.$refs[formName].resetFields();
      },
      delAccount() {
        this.axios({
          method: "delete",
          url: "/url/personnelManagement/delAccount",
          data: this.delAccountFrom,
        }).then((res) => {
          this.delAccountShow = false;
          this.getAllPersion(1, 10);
          if (res.data.success == "true") {
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else {
            this.delAccountShow = false;
            this.getAllPersion(1, 10);
            this.$message({
              message: "删除失败",
              type: "error",
            });
          }
        });
      },
      delAccountClose() {
        this.delAccountFrom.id = {};
        this.delAccountShow = false;
      },
      delAccountIsShow(row) {
        this.delAccountFrom.id = row.id;
        this.delAccountFrom.userName = row.userName;
        this.delAccountShow = true;
      },
      submitAddAccountForm(formName) {
        this.addAccountFrom.tenantCode =
                this.addAccountFrom.tenantCode.toString();
        this.addAccountFrom.machineId =
                this.addAccountFrom.machineId.toString();
        this.addAccountFrom.password = md5(this.addAccountFrom.password)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.axios({
              method: "post",
              url: "/url/personnelManagement/addAccount",
              data: this.addAccountFrom,
            }).then((res) => {
              this.$refs[formName].resetFields();
              this.isShop = -1
              this.isMachine = -1
              this.addAccountTable = false;
              this.getAllPersion(1, 10);
              this.$message({
                message: "添加成功",
                type: "success",
              });
            });
          } else {
            this.getAllPersion(1, 10);
            this.$message({
              message: "添加失败",
              type: "error",
            });
            return false;
          }
        });
      },
      resetAddAccountForm(formName) {
        this.$refs[formName].resetFields();
        this.isShop = -1
        this.isMachine = -1
        this.tenantIsShow = true
        this.addAccountFrom.machineId = ""
        this.addAccountFrom.shopId = ""
      },
      addAccountFun() {
        this.addAccountTable = true;
      },
      findAccountSubmit() {
        this.getAllPersion(1, 10);
      },
      accountCloseFun() {
        this.roleSelectValue = -1;
        this.frozenStatusValue = -1;
        this.roleValue = {};
        this.accountfrozenStatus = {};
        this.accountRowData = {};
        this.gridData = {};
      },
      roleSelect(val) {
        this.roleSelectValue = val;
      },
      frozenStatusSelect(val) {
        this.frozenStatusValue = val;
      },
      getRoleList() {
        this.axios({
          method: "get",
          url: "/url/personnelManagement/getRoleList",
        }).then((res) => {
          this.roleOptions = res.data.data;
        });
      },
      getTenantList() {
        this.axios({
          method: "get",
          url: "/url/personnelManagement/getTenantList",
        }).then((res) => {
          this.tenantOptions = res.data.data;
        });
      },
      // eslint-disable-next-line no-unused-vars
      getAccountDetails(accountId) {},
      personnelManagementHandleClick(row) {
        row.lastLoginTime = this.getYMDHMS(row.lastLoginTime);
        this.accountRowData = row;
        this.dialogTableVisible = true;
        this.gridData = this.accountRowData;
        this.roleValue = this.gridData.role;
        this.roleSelectValue = this.gridData.role.id;
        if (row.frozenStatus == 1) {
          this.accountfrozenStatus = {
            value: 1,
            label: "冻结",
          };
        } else {
          this.accountfrozenStatus = {
            value: 0,
            label: "正常",
          };
        }
        this.frozenStatusValue = this.gridData.frozenStatus;
        let accountTenant = this.gridData.tenantCode;
        let arr = accountTenant.split(",");
        this.accountTenantCodeList = arr;
        this.originalAccountTenantCodeList = arr;
        this.accountRowName = this.gridData.role.name;
      },
      send() {
        if (this.value1.length == 0) {
          this.$message.error("请先选择日期");
        } else {
          let signTime = new Date().getTime();
          let startTime = this.value1[0];
          let endTime = this.value1[1];
          this.$store.commit("nowsign", signTime);
          let urla =
                  "?startTime=" +
                  startTime +
                  "&endTime=" +
                  endTime +
                  "&language=" +
                  this.$store.state.lang +
                  "&sign=" +
                  this.$store.state.sign +
                  "&auth_Code=" +
                  this.$store.state.authCode +
                  "&sign_time=" +
                  signTime +
                  "&route=" +
                  this.$store.state.newroute +
                  "&factory_id=" +
                  this.$store.state.factoryId;
          window.open("/url/downloadSuggestionForTime" + urla, "_blank");
        }
      },
      getVideoList(pageNum, pageSize) {
        this.axios({
          method: "get",
          url: "/url/fileList",
          params: {
            pageNum: pageNum,
            pageSize: pageSize,
            groupId: this.value,
            fileName: this.input1,
          },
        }).then((res) => {
          this.tableData = res.data.data.list;
          this.listTotal = res.data.data.total;
          this.options = res.data.selectData;
        });
      },
      submitUpload() {
        if (this.input == "" || this.input == null) {
          this.$message({
            message: "视频所属的组不能为空",
            type: "warning",
          });
          return;
        }
        this.$refs.upload.submit();
      },
      handleRemove(file, files) {
        console.log(files);
        },
      handlePreview(file) {
        console.log(file);
        },
      getToken() {
        let signTime1 = new Date().getTime();
        this.$store.commit("nowsign", signTime1);
        this.signTime = signTime1;
        this.sign = this.$store.state.sign;
        this.factory_id = this.$store.state.factoryId;
        this.auth_Code = this.$store.state.authCode;
        this.route = this.$store.state.newroute;
        this.language = this.$store.state.lang;
        this.urlHeaders = {
          sign_time: signTime1,
          sign: this.sign,
          language: this.language,
          route: this.route,
          auth_Code: this.auth_Code,
          factory_id: this.factory_id,
        };
      },
      handleClick(dataValue) {
        let urla =
                "&language=" +
                this.language +
                "&sign=" +
                this.sign +
                "&auth_Code=" +
                this.auth_Code +
                "&sign_time=" +
                this.signTime +
                "&route=" +
                this.route +
                "&factory_id=" +
                this.factory_id;
        this.filepaths =
                "/url/downloadQRCode?" +
                "groupId=" +
                dataValue.groupId +
                "&videoId=" +
                dataValue.id +
                urla;
        this.fileimage = true;
      },
      success() {
        this.files = [];
        this.$message({
          message: "上传成功",
          type: "success",
        });
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 分页
      handleCurrentChange(val) {
        this.getVideoList(val, 10);
      },
      accountHandleCurrentChange(val) {
        this.getAllPersion(val, 10);
      },
      handleCurrentSizeChange(val) {
        this.nowPageSize = val;
        this.getEventRecordList();
      },
      accountHandleCurrentSizeChange(val) {
        this.accountNowPageSize = val;
        this.getEventRecordList();
      },
      getEventRecordListPage() {
        this.loading = true;
        this.typeId = Number(localStorage.getItem("typeId"))
                ? Number(localStorage.getItem("typeId"))
                : "";
        this.startTime = localStorage.getItem("startTime");
        this.endTime = localStorage.getItem("endTime");
        this.eventCode = localStorage.getItem("eventCode");
        this.groupId = Number(localStorage.getItem("groupId"))
                ? Number(localStorage.getItem("groupId"))
                : "";
        this.emId = Number(localStorage.getItem("emId"))
                ? Number(localStorage.getItem("emId"))
                : "";
        this.duration = localStorage.getItem("duration");
        this.machineId = localStorage.getItem("machineId");
        this.startDate = formatDate(
                new Date(this.startTime),
                "yyyy-MM-dd hh:mm:ss"
        );
        this.endDate = formatDate(new Date(this.endTime), "yyyy-MM-dd hh:mm:ss");
        this.selectTime = [this.startDate, this.endDate];
        this.getEventRecord();
      },
      getEventRecordList() {
        if (this.startTime == "" && this.endTime == "") {
          this.$message.error(this.$t("EventRecord.selectTimeError"));
          return;
        }
        this.nowPage = 1;
        this.loading = true;
        localStorage.setItem("typeId", this.typeId);
        localStorage.setItem("startTime", this.startTime);
        localStorage.setItem("endTime", this.endTime);
        localStorage.setItem("eventCode", this.eventCode);
        localStorage.setItem("groupId", this.groupId);
        localStorage.setItem("emId", this.emId);
        localStorage.setItem("duration", this.duration);
        localStorage.setItem("machineId", this.machineId);
        this.dlmachineId = this.machineId;
        this.dleventCode = this.eventCode;
        this.dltypeId = this.typeId;
        this.dlgroupId = this.groupId;
        this.dlemId = this.emId;
        this.dlduration = this.duration;
        this.dlstartTime = this.startTime;
        this.dlendTime = this.endTime;
        this.getEventRecord();
      },
      getVideoListByGroupId() {
        this.getVideoList(1, 10);
      },
      grafanaSend() {
        let fv = this.factoryValue.value;
        let gv = this.grafanaValue.value;
        let id = this.input;
        if (id == undefined) {
          id = 0;
        }
        this.axios({
          method: "get",
          url: "/url" + gv + "/" + fv + "/" + id,
        });
      },
      fileValue() {
        this.actionUrl = "/url/uploadAliYunFile?groupName=" + this.input;
      },
      sendUser() {
        if (this.value1.length == 0) {
          this.$message.error("请先选择日期");
        } else {
          let signTime = new Date().getTime();
          let startTime = this.value1[0];
          let endTime = this.value1[1];
          this.$store.commit("nowsign", signTime);
          let urla =
                  "?startDate=" +
                  startTime +
                  "&endDate=" +
                  endTime +
                  "&language=" +
                  this.$store.state.lang +
                  "&sign=" +
                  this.$store.state.sign +
                  "&auth_Code=" +
                  this.$store.state.authCode +
                  "&sign_time=" +
                  signTime +
                  "&route=" +
                  this.$store.state.newroute +
                  "&factory_id=" +
                  this.$store.state.factoryId;
          window.open("/url/exportRequestLog" + urla, "_blank");
        }
      },
      getVideoGroup(data) {
        if (data == "") {
          this.$message({
            message: "请选择组",
            type: "warning",
          });
          return;
        }
        var dataValue = {
          groupId: this.value,
          id: 0,
        };
        this.handleClick(dataValue);
      },
      getAllPersion(pageNum, pageSize) {
        this.axios({
          method: "post",
          url: "/url/personnelManagement/getList",
          params: {
            pageNum: pageNum,
            pageSize: pageSize,
          },
          data: this.accountForm,
        }).then((res) => {
          this.personnelManagementTableData = res.data.data.list;
          this.accountListTotal = res.data.data.total;
        });
      },
      getYMDHMS(timestamp) {
        let time = new Date(timestamp);
        let year = time.getFullYear();
        const month = (time.getMonth() + 1).toString().padStart(2, "0");
        const date = time.getDate().toString().padStart(2, "0");
        const hours = time.getHours().toString().padStart(2, "0");
        const minute = time.getMinutes().toString().padStart(2, "0");
        const second = time.getSeconds().toString().padStart(2, "0");
        return (
                year +
                "-" +
                month +
                "-" +
                date +
                " " +
                hours +
                ":" +
                minute +
                ":" +
                second
        );
      },
      updateAccount() {
        if (this.roleSelectValue == this.roleValue.id) {
          this.updateAccountFrom.role.id = null;
        } else {
          this.updateAccountFrom.role.id = this.roleSelectValue;
        }
        if (this.frozenStatusValue == this.accountfrozenStatus.value) {
          this.updateAccountFrom.frozenStatus = null;
        } else {
          this.updateAccountFrom.frozenStatus = this.frozenStatusValue;
        }
        if (this.tenantCodeIsSame) {
          this.updateAccountFrom.tenantCode = null;
        } else {
          this.updateAccountFrom.tenantCode =
                  this.accountTenantCodeList.toString();
        }
        this.updateAccountFrom.id = this.gridData.id;
        this.axios({
          method: "put",
          url: "/url/personnelManagement/updateAccount",
          data: this.updateAccountFrom,
        }).then((res) => {
          this.dialogTableVisible = false;
          if (res.data.success == "true") {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "修改失败",
              type: "error",
            });
          }
          this.getAllPersion(1, 10);
        });
      },
      accountUpdateShowBool() {
        return this.roleSelectValue != this.roleValue.id ||this.frozenStatusValue != this.accountfrozenStatus.value || !this.tenantCodeIsSame
      },
      accountUpdateTenantIsSeam() {
        this.tenantCodeIsSame = true
        let originalTenantCodeList = this.originalAccountTenantCodeList;
        let tenantCodeList = this.accountTenantCodeList;
        if (originalTenantCodeList.length != tenantCodeList.length) {
          this.tenantCodeIsSame = false
        } else {
          originalTenantCodeList.forEach((item) => {
            if (tenantCodeList.indexOf(item) === -1) {
              this.tenantCodeIsSame = false
            }
          })
        }
      },
       // 生成二维码记录导出
      downloadCode() {
        if (this.codeSearchDate.length == 0) {
          this.$message.error("请先选择日期");
        } else {
          let signTime = new Date().getTime();
          let startTime = this.codeSearchDate[0];
          let endTime = this.codeSearchDate[1];
          this.$store.commit("nowsign", signTime);
          let urla =
                  "?startDate=" +
                  startTime +
                  "&endDate=" +
                  endTime +
                  "&language=" +
                  this.$store.state.lang +
                  "&sign=" +
                  this.$store.state.sign +
                  "&auth_Code=" +
                  this.$store.state.authCode +
                  "&sign_time=" +
                  signTime +
                  "&route=" +
                  this.$store.state.newroute +
                  "&factory_id=" +
                  this.$store.state.factoryId;
          window.open("/url/wxBarcode/export" + urla, "_blank");
        }
      },
    },
    mounted() {
      this.getVideoList(1, 10);
      this.getToken();
      this.getAllPersion(1, 10);
      this.getRoleList();
      this.getTenantList();
    },
    watch: {
      // eslint-disable-next-line no-unused-vars
      roleSelectValue: function (val, oldVal) {
        this.accountUpdateTenantIsSeam()
        this.accountUpdateShow = this.accountUpdateShowBool()
      },
      // eslint-disable-next-line no-unused-vars
      frozenStatusValue: function (val, oldVal) {
        this.accountUpdateTenantIsSeam()
        this.accountUpdateShow = this.accountUpdateShowBool()
      },
      // eslint-disable-next-line no-unused-vars
      accountTenantCodeList: function (val, oldVal) {
        this.accountUpdateTenantIsSeam()
        this.accountUpdateShow = this.accountUpdateShowBool()
      },
      deep: true,
    },
  };
</script>
<style scoped>
  .fontLineHeight {
    line-height: 45px;
  }
  .record{
    height: 100%;
  }
  .divz {
    display: inline-block;
  }

  .el-image-viewer__wrapper {
    z-index: 3000 !important;
  }
  .pagination{
  text-align: center;
  margin-top: 35px;
 }
</style>